import Vue from 'vue'
import VueRouter from 'vue-router'

import AppLayout from '@/layouts/app-layout.vue'
import Home from '@/pages/home.vue'
import Login from '@/pages/login.vue'

const routes = [
  // 公共访问页面
  {path: '/login', component: Login},
  {path: '/', component: AppLayout, children: [{path: '', component: Home}]},
  {path: '/home/user-setting', component: AppLayout, children: [{path: '', 
    component: () => import(/* webpackChunkName: "common" */ '@/pages/home/user-setting.vue')}]},
  {path: '/home/change-password', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "common" */ '@/pages/home/change-password.vue')}]},
  {path: '/home/software', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "common" */ '@/pages/home/software.vue')}]},
  
  // 系统管理员菜单项链接
  {path: '/configs', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "sys" */ '@/pages/config/index.vue')}]},
  {path: '/config', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "sys" */ '@/pages/config/get.vue')}]},

  {path: '/permit-items', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "sys" */ '@/pages/permit-item/index.vue')}]},
  {path: '/permit-item', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "sys" */ '@/pages/permit-item/get.vue')}]},

  {path: '/permit-urls', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "sys" */ '@/pages/permit-url/index.vue')}]},
  {path: '/permit-url', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "sys" */ '@/pages/permit-url/get.vue')}]},

  {path: '/dicts', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "sys" */ '@/pages/dict/index.vue')}]},
  {path: '/dict', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "sys" */ '@/pages/dict/get.vue')}]},

    {path: '/waterDicts', component: AppLayout, children: [{path: '',
      component: () => import(/* webpackChunkName: "sys" */ '@/pages/waterDict/index.vue')}]},
    {path: '/waterDict', component: AppLayout, children: [{path: '',
      component: () => import(/* webpackChunkName: "sys" */ '@/pages/waterDict/get.vue')}]},
  
      {path: '/codeDicts', component: AppLayout, children: [{path: '',
      component: () => import(/* webpackChunkName: "sys" */ '@/pages/codeDict/index.vue')}]},
    {path: '/codeDict', component: AppLayout, children: [{path: '',
      component: () => import(/* webpackChunkName: "sys" */ '@/pages/codeDict/get.vue')}]},
  
  {path: '/roles', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "sys" */ '@/pages/role/index.vue')}]},
  {path: '/role', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "sys" */ '@/pages/role/get.vue')}]},

  {path: '/users', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "admin" */ '@/pages/user/index.vue')}]},
  {path: '/user', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "admin" */ '@/pages/user/get.vue')}]},
 /* {path: '/users2', component: AppLayout, children: [{path: '',
    component: () => import('@/pages/user/index2.vue')}]},
  {path: '/user2', component: AppLayout, children: [{path: '',
    component: () => import('@/pages/user/get2.vue')}]},
  {path: '/onlineTerminates', component: AppLayout, children: [{path: '',
    component: () => import('@/pages/user/online-terminates.vue')}]},*/

   /* {path: '/index',name: 'index',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/index')}]},
    {
      path: '/plan',
      name: 'plan',
      component: () =>import ('@/pages/plan')
    },*/
    
    {path: '/facilityCategory',name: 'checkedUnit',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/facilityCategory/list')}]},
    {path: '/checkedUnit',name: 'checkedUnit',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/checkedUnit')}]},
    {path: '/waterSource',name: 'waterSource',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/waterSource')}]},
    {path: '/iot',name: 'waterSource',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/iot')}]},
    {path: '/iotAlert',name: 'waterSource',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/iotAlert')}]},
    {path: '/warnAlert',name: 'warnAlert',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/warnAlert')}]},
    {path: '/waterDevice',name: 'waterDevice',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/waterDevice')}]},
    {path: '/waterSourceAlert',name: 'waterSourceAlert',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/waterSourceAlert')}]},
    {path: '/waterFault',name: 'waterFault',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/waterFault')}]},
    {path: '/log',name: 'log',component: AppLayout,children: [
    {path: '',component: () =>import ('@/pages/log')}]},

    {path: '/waterStatistics', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "admin" */ '@/pages/statistics/water.vue')}]},
  {path: '/units', component: AppLayout, children: [{path: '',
    component: () => import( '@/pages/unit/index.vue')}]},
  {path: '/unit', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "admin" */ '@/pages/unit/get.vue')}]},
  /*{path: '/keyUnits', component: AppLayout, children: [{path: '',
    component: () => import(/!* webpackChunkName: "admin" *!/ '@/pages/unit/indexKeyUnits.vue')}]},
  {path: '/keyUnit', component: AppLayout, children: [{path: '',
    component: () => import(/!* webpackChunkName: "admin" *!/ '@/pages/unit/getKeyUnits.vue')}]},*/



  {path: '/boards', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "admin" */ '@/pages/board/index.vue')}]},
  {path: '/board', component: AppLayout, children: [{path: '',
    component: () => import(/* webpackChunkName: "admin" */ '@/pages/board/get.vue')}]},
  
  /* {path: '/app-msgs', component: AppLayout, children: [{path: '',
    component: () => import('@/pages/app-msg/index.vue')}]},
  {path: '/app-msg', component: AppLayout, children: [{path: '',
    component: () => import('@/pages/app-msg/get.vue')}]}, */


  // 普通用户菜单链接
  {
    path: '/404',
    name: '404',
    component: () =>import ('@/pages/404')
  },{ path: '*', redirect: '/404', hidden: true }
]

Vue.use(VueRouter)

export default new VueRouter({
  //mode: 'history',
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js